import { Wizard } from "react-use-wizard";
import IntroStep from "./intro";
import BodyDimensionsStep from "./bodyDimensions";
import MultiChoiceStep from "./multiChoice";
import MedicalConditionsPart2Step from "./medicalConditions2";
import MedicalHistoryStep from "./medicalHistory";
import SingleChoiceStep from "./singleChoice";
import SubmitStep from "./submit";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import createPersistedState from "use-persisted-state";
import { useTranslation } from "react-i18next";
import { translations } from "../../locales/healthInfo";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ConditionDurationStep from "./conditionDuration";

//TODO: To refactor
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

function HealthInfoWizard() {
  const search = useLocation().search;
  const startFrom = new URLSearchParams(search).get("i");
  const rawFrom = new URLSearchParams(search).get("from");
  const from = rawFrom ? decodeURIComponent(rawFrom) : null;

  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const [state, setState] = useState({});
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  // Get the route we came from
  const fromRoute = from;

  const getUrl = (pid) => `/api/v1/users/profile/${pid}/healthinfo`;

  useEffect(() => {
    fetchHealthInfo();
  }, [pid, token]);

  const fetchHealthInfo = () => {
    fetch(getUrl(pid), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"] && responseData["healthInfo"]) {
          processResponse(responseData["healthInfo"]);
        }
      });
  };

  //TODO: Refactor this please!! Too lengthy :)
  const processResponse = (info) => {
    let responses = {};
    responses["BodyDim"] = {};
    responses["BodyDim"]["_state"] = {};
    responses["MedCond1"] = {};
    responses["MedCond2"] = {};
    responses["MedHist"] = {};
    responses["SurgHist"] = {};
    responses["MedicineHist"] = {};
    responses["AllergyHist"] = {};
    responses["SuppHist"] = {};
    responses["SleepDuration"] = {};
    responses["SleepQuality"] = {};
    responses["StressLevel"] = {};
    responses["DietPref"] = {};
    responses["BreakfastPref"] = {};
    responses["LunchPref"] = {};
    responses["DinnerPref"] = {};
    responses["IsExercise"] = {};
    responses["IsPhysioConsulted"] = {};
    responses["MedCondDuration"] = {};
    responses["MedCondDuration"]["_state"] = {
      ht: "",
      hpt: "",
      ckd: "",
      dm: "",
      dyslipidemia: "",
      ihd: "",
    };
    for (let i = 0; i < info.length; i++) {
      let r = info[i];
      const questionCode = r["code"];
      switch (questionCode) {
        case "Q1":
          responses["BodyDim"]["_state"]["height"] = r["response"] || "";
          break;
        case "Q2":
          responses["BodyDim"]["_state"]["weight"] = r["response"] || "";
          break;
        case "Q3":
          responses["MedCond1"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["MedCond1"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              value: c["text"], //TODO: Ideally this should be in english
            };
          }
          break;
        case "Q4":
          responses["MedCond2"]["_state"] = {};
          responses["MedCond2"]["_state"]["choiceSelection"] = {};
          responses["MedCond2"]["_state"]["isNoneApplicableInit"] = false;
          responses["MedCond2"]["_state"]["isOtherOptionSelectedInit"] = false;
          responses["MedCond2"]["_state"]["otherOptionValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            if (code === "Q4C6") {
              // Other Option Selected
              responses["MedCond2"]["_state"]["isOtherOptionSelectedInit"] =
                c["correct"];
              responses["MedCond2"]["_state"]["otherOptionValueInit"] =
                c["text"];
            } else if (code === "Q4C7") {
              // None Option Selected
              responses["MedCond2"]["_state"]["isNoneApplicableInit"] =
                c["correct"];
            } else {
              responses["MedCond2"]["_state"]["choiceSelection"][c["code"]] = {
                checked: c["correct"],
                id: c["code"],
                value: c["text"],
              };
            }
          }
          break;
        case "Q5":
          responses["MedHist"]["_state"] = {};
          responses["MedHist"]["_state"]["textValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];
            if (code === "Q5C1" && isSelected) {
              responses["MedHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["MedHist"]["_state"]["textValueInit"] = c["text"];
            } else if (code === "Q5C2" && isSelected) {
              responses["MedHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q12":
          responses["SurgHist"]["_state"] = {};
          responses["SurgHist"]["_state"]["textValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];
            if (code === "Q12C1" && isSelected) {
              responses["SurgHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["SurgHist"]["_state"]["textValueInit"] = c["text"];
            } else if (code === "Q12C2" && isSelected) {
              responses["SurgHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q6":
          responses["MedicineHist"]["_state"] = {};
          responses["MedicineHist"]["_state"]["textValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];
            if (code === "Q6C1" && isSelected) {
              responses["MedicineHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["MedicineHist"]["_state"]["textValueInit"] = c["text"];
            } else if (code === "Q6C2" && isSelected) {
              responses["MedicineHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q7":
          responses["AllergyHist"]["_state"] = {};
          responses["AllergyHist"]["_state"]["textValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];
            if (code === "Q7C1" && isSelected) {
              responses["AllergyHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["AllergyHist"]["_state"]["textValueInit"] = c["text"];
            } else if (code === "Q7C2" && isSelected) {
              responses["AllergyHist"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q8":
          responses["SuppHist"]["_state"] = {};
          responses["SuppHist"]["_state"]["choiceSelection"] = {};
          responses["SuppHist"]["_state"]["isOtherOptionSelectedInit"] = false;
          responses["SuppHist"]["_state"]["otherOptionValueInit"] = "";
          responses["SuppHist"]["_state"]["isNoneApplicableInit"] = false;
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            if (code === "Q8C4") {
              // Other Option Selected
              responses["SuppHist"]["_state"]["isOtherOptionSelectedInit"] =
                c["correct"];
              responses["SuppHist"]["_state"]["otherOptionValueInit"] =
                c["text"];
            } else if (code === "Q8C5") {
              // None Option Selected
              responses["SuppHist"]["_state"]["isNoneApplicableInit"] =
                c["correct"];
            } else {
              responses["SuppHist"]["_state"]["choiceSelection"][c["code"]] = {
                checked: c["correct"],
                id: c["code"],
                value: c["text"],
              };
            }
          }
          break;
        case "Q9":
          responses["SleepDuration"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["SleepDuration"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q9.options." + c["code"]),
                value: translations["EN"]["Q9"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q10":
          responses["SleepQuality"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["SleepQuality"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q10.options." + c["code"]),
                value: translations["EN"]["Q10"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q11":
          responses["StressLevel"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["StressLevel"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q11.options." + c["code"]),
                value: translations["EN"]["Q11"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q13":
          responses["DietPref"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["DietPref"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              value: c["text"],
            };
          }
          break;
        case "Q14":
          responses["BreakfastPref"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["BreakfastPref"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              value: c["text"],
            };
          }
          break;
        case "Q15":
          responses["BreakfastTime"] = {};
          responses["BreakfastTime"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["BreakfastTime"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q15.options." + c["code"]),
                value: translations["EN"]["Q15"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q16":
          responses["LunchPref"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["LunchPref"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              value: c["text"],
            };
          }
          break;
        case "Q17":
          responses["LunchTime"] = {};
          responses["LunchTime"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["LunchTime"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q17.options." + c["code"]),
                value: translations["EN"]["Q17"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q18":
          responses["DinnerPref"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["DinnerPref"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              value: c["text"],
            };
          }
          break;
        case "Q19":
          responses["DinnerTime"] = {};
          responses["DinnerTime"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const isSelected = c["correct"];
            if (isSelected) {
              responses["DinnerTime"]["_state"]["selectedChoiceInit"] = {
                id: c["code"],
                text: t("Q19.options." + c["code"]),
                value: translations["EN"]["Q19"]["options"][c["code"]],
              };
            }
          }
          break;
        case "Q20":
          responses["IsExercise"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];

            if (code === "Q20C1" && isSelected) {
              responses["IsExercise"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["IsExercise"]["_state"]["textValueInit"] = c["text"];
            } else if (code === "Q20C2" && isSelected) {
              responses["IsExercise"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q21":
          responses["ExerciseType"] = {};
          responses["ExerciseType"]["_state"] = {};
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            responses["ExerciseType"]["_state"][c["code"]] = {
              checked: c["correct"],
              id: c["code"],
              text: t("Q21.options." + c["code"]),
              value: translations["EN"]["Q21"]["options"][c["code"]],
            };
          }
          break;
        case "Q22":
          responses["IsPhysioConsulted"]["_state"] = {};
          responses["IsPhysioConsulted"]["_state"]["textValueInit"] = "";
          for (let i = 0; i < r["choices"].length; i++) {
            const c = r["choices"][i];
            const code = c["code"];
            const isSelected = c["correct"];
            if (code === "Q22C1" && isSelected) {
              responses["IsPhysioConsulted"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.yes"),
                id: c["code"],
                value: translations["EN"]["hi"]["yes"],
              };
              responses["IsPhysioConsulted"]["_state"]["textValueInit"] =
                c["text"];
            } else if (code === "Q22C2" && isSelected) {
              responses["IsPhysioConsulted"]["_state"]["selectedChoiceInit"] = {
                text: t("hi.no"),
                id: c["code"],
                value: translations["EN"]["hi"]["no"],
              };
            }
          }
          break;
        case "Q3C1Q":
          responses["MedCondDuration"]["_state"]["ht"] = r["response"] || "";
          break;
        case "Q3C2Q":
          responses["MedCondDuration"]["_state"]["hpt"] = r["response"] || "";
          break;
        case "Q3C3Q":
          responses["MedCondDuration"]["_state"]["ckd"] = r["response"] || "";
          break;
        case "Q3C4Q":
          responses["MedCondDuration"]["_state"]["dm"] = r["response"] || "";
          break;
        case "Q3C5Q":
          responses["MedCondDuration"]["_state"]["dyslipidemia"] =
            r["response"] || "";

          break;
        case "Q3C6Q":
          responses["MedCondDuration"]["_state"]["ihd"] = r["response"] || "";
          break;
      }
    }
    //console.log(info);
    //console.log("=======");
    //console.log(responses);
    setState(responses);
  };

  const hasOption = (optionCode, stepState) => {
    if (stepState["formatted_response"]) {
      let selectedOptions = [];
      if (stepState["formatted_response"].constructor === Array) {
        selectedOptions = stepState["formatted_response"][0]["choices"]; //TODO: Hack need to check this thoroughly
      } else {
        selectedOptions = stepState["formatted_response"]["choices"];
      }
      return selectedOptions.find(
        (selectedOption) => selectedOption["code"] === optionCode
      );
    } else {
      return false;
    }
  };

  const updateStatus = (deltaState) => {
    console.log(state);
    console.log(deltaState);
    const stepKey = Object.keys(deltaState)[0];
    console.log(stepKey);
    //console.log(hasOption('Q20C2', deltaState['isExercise']));
    //Clear state when jumps occur. TODO: Find better way to do this

    if (
      stepKey === "BreakfastPref" &&
      hasOption("Q14C14", deltaState["BreakfastPref"])
    ) {
      deltaState["BreakfastTime"] = {};
      deltaState["BreakfastTime"]["_state"] = null;
    } else if (
      stepKey === "LunchPref" &&
      hasOption("Q16C13", deltaState["LunchPref"])
    ) {
      deltaState["LunchTime"] = {};
      deltaState["LunchTime"]["_state"] = null;
    } else if (
      stepKey === "DinnerPref" &&
      hasOption("Q18C13", deltaState["DinnerPref"])
    ) {
      deltaState["DinnerTime"] = {};
      deltaState["DinnerTime"]["_state"] = null;
    } else if (
      stepKey === "IsExercise" &&
      hasOption("Q20C2", deltaState["IsExercise"])
    ) {
      deltaState["ExerciseType"] = {};
      deltaState["ExerciseType"]["_state"] = null;
    } else if (
      stepKey === "MedCond1" &&
      hasOption("Q3C7", deltaState["MedCond1"])
    ) {
      deltaState["MedCondDuration"] = {};
      deltaState["MedCondDuration"]["_state"] = null;
    }

    setState({
      ...state,
      ...deltaState,
    });
  };

  const getSubState = (qKey) => {
    //console.log(state.hasOwnProperty(qKey)? state[qKey]['_state']:null);
    return state.hasOwnProperty(qKey) ? state[qKey]["_state"] : null;
  };

  return (
    <>
      <Wizard startIndex={0}>
        <IntroStep fromLink={from} />
        <BodyDimensionsStep
          qKey={"BodyDim"}
          initState={getSubState("BodyDim")}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          hideLibrary={true}
          pageTitle={t("hi.title")}
          qKey={"MedCond1"}
          question={t("Q3.question")}
          questionCode={"Q3"}
          choices={[
            {
              value: "HT (Blood Pressure)",
              text: t("Q3.options.Q3C1"),
              id: "Q3C1",
            },
            { value: "Hypo-Thyroid", text: t("Q3.options.Q3C2"), id: "Q3C2" },
            {
              value: "CKD (Kidney Disease)",
              text: t("Q3.options.Q3C3"),
              id: "Q3C3",
            },
            { value: "DM (Diabetes)", text: t("Q3.options.Q3C4"), id: "Q3C4" },
            {
              value: "Dyslipidemia (Cholesterol)",
              text: t("Q3.options.Q3C5"),
              id: "Q3C5",
            },
            {
              value: "IHD (Ischemic Heart Disease)",
              text: t("Q3.options.Q3C6"),
              id: "Q3C6",
            },
            {
              value: "None of the above",
              text: t("Q3.options.Q3C7"),
              id: "Q3C7",
              exclusive: true,
            },
          ]}
          initState={getSubState("MedCond1")}
          onSubmitHandler={updateStatus}
          nextConfig={{ optionCode: "Q3C7", nextStep: 4 }}
        />
        <ConditionDurationStep
          hideLibrary={true}
          pageTitle={t("hi.title")}
          qKey={"MedCondDuration"}
          question={t("Q3.question")}
          questionCode={"Q3"}
          patientsConditions={getSubState("MedCond1")}
          initState={getSubState("MedCondDuration")}
          onSubmitHandler={updateStatus}
        />
        <MedicalConditionsPart2Step
          hideLibrary={true}
          question={t("Q4.question")}
          questionCode={"Q4"}
          choices={[
            { value: "Acidity", text: t("Q4.options.Q4C1"), id: "Q4C1" },
            { value: "Swelling", text: t("Q4.options.Q4C2"), id: "Q4C2" },
            { value: "Hair Loss", text: t("Q4.options.Q4C3"), id: "Q4C3" },
            { value: "Rash", text: t("Q4.options.Q4C4"), id: "Q4C4" },
            { value: "Ulcers", text: t("Q4.options.Q4C5"), id: "Q4C5" },
          ]}
          noneOptionText={t("hi.nota")}
          qKey={"MedCond2"}
          initState={getSubState("MedCond2")}
          otherChoiceCode={"Q4C6"}
          noneChoiceCode={"Q4C7"}
          onSubmitHandler={updateStatus}
        />
        <MedicalHistoryStep
          question={t("Q5.question")}
          questionCode={"Q5"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q5C1" },
            { value: "No", text: t("hi.no"), id: "Q5C2" },
          ]}
          yesChoiceCode={"Q5C1"}
          qKey={"MedHist"}
          initState={getSubState("MedHist")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MedicalHistoryStep
          question={t("Q12.question")}
          questionCode={"Q12"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q12C1" },
            { value: "No", text: t("hi.no"), id: "Q12C2" },
          ]}
          yesChoiceCode={"Q12C1"}
          qKey={"SurgHist"}
          initState={getSubState("SurgHist")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MedicalHistoryStep
          question={t("Q6.question")}
          questionCode={"Q6"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q6C1" },
            { value: "No", text: t("hi.no"), id: "Q6C2" },
          ]}
          yesChoiceCode={"Q6C1"}
          yesDescription={t("Q6.yesText")}
          qKey={"MedicineHist"}
          hideLibrary={true}
          initState={getSubState("MedicineHist")}
          onSubmitHandler={updateStatus}
        />
        <MedicalHistoryStep
          question={t("Q7.question")}
          questionCode={"Q7"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q7C1" },
            { value: "No", text: t("hi.no"), id: "Q7C2" },
          ]}
          yesChoiceCode={"Q7C1"}
          yesDescription={t("Q7.yesText")}
          hideLibrary={true}
          qKey={"AllergyHist"}
          initState={getSubState("AllergyHist")}
          onSubmitHandler={updateStatus}
        />
        <MedicalConditionsPart2Step
          question={t("Q8.question")}
          questionCode={"Q8"}
          choices={[
            { value: "Iron", text: t("Q8.options.Q8C1"), id: "Q8C1" },
            { value: "Calcium", text: t("Q8.options.Q8C2"), id: "Q8C2" },
            { value: "Protein", text: t("Q8.options.Q8C3"), id: "Q8C3" },
          ]}
          noneOptionText={t("Q8.noneText")}
          otherChoiceCode={"Q8C4"}
          noneChoiceCode={"Q8C5"}
          qKey={"SuppHist"}
          initState={getSubState("SuppHist")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q9.question")}
          questionCode={"Q9"}
          choices={[
            {
              value: "Less than 6 hours",
              text: t("Q9.options.Q9C1"),
              id: "Q9C1",
            },
            { value: "6 to 8 hours", text: t("Q9.options.Q9C2"), id: "Q9C2" },
            {
              value: "More than 8 hours",
              text: t("Q9.options.Q9C3"),
              id: "Q9C3",
            },
          ]}
          initState={getSubState("SleepDuration")}
          qKey={"SleepDuration"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q10.question")}
          questionCode={"Q10"}
          choices={[
            { value: "Good", text: t("Q10.options.Q10C1"), id: "Q10C1" },
            { value: "Disturbed", text: t("Q10.options.Q10C2"), id: "Q10C2" },
          ]}
          initState={getSubState("SleepQuality")}
          qKey={"SleepQuality"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q11.question")}
          questionCode={"Q11"}
          choices={[
            { value: "Low", text: t("Q11.options.Q11C1"), id: "Q11C1" },
            { value: "Medium", text: t("Q11.options.Q11C2"), id: "Q11C2" },
            { value: "High", text: t("Q11.options.Q11C3"), id: "Q11C3" },
            { value: "No Stress", text: t("Q11.options.Q11C4"), id: "Q11C4" },
            {
              value: "Sensitive nature",
              text: t("Q11.options.Q11C5"),
              id: "Q11C5",
            },
          ]}
          initState={getSubState("StressLevel")}
          qKey={"StressLevel"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          pageTitle={t("hi.title")}
          qKey={"DietPref"}
          question={t("Q13.question")}
          questionCode={"Q13"}
          choices={[
            { value: "Vegetarian", text: t("Q13.options.Q13C1"), id: "Q13C1" },
            {
              value: "Vegetarian + Egg",
              text: t("Q13.options.Q13C2"),
              id: "Q13C2",
            },
            {
              value: "Non-Vegetarian",
              text: t("Q13.options.Q13C3"),
              id: "Q13C3",
            },
          ]}
          initState={getSubState("DietPref")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          pageTitle={t("hi.title")}
          qKey={"BreakfastPref"}
          question={t("Q14.question")}
          questionCode={"Q14"}
          choices={[
            {
              value: "Tea / Coffee",
              text: t("Q14.options.Q14C1"),
              id: "Q14C1",
            },
            { value: "Poha / Upma", text: t("Q14.options.Q14C2"), id: "Q14C2" },
            {
              value: "Rice / Idli / Dosa",
              text: t("Q14.options.Q14C3"),
              id: "Q14C3",
            },
            {
              value: "Bread / Biscuits",
              text: t("Q14.options.Q14C4"),
              id: "Q14C4",
            },
            {
              value: "Milk / Yogurt / Paneer / Cheese",
              text: t("Q14.options.Q14C5"),
              id: "Q14C5",
            },
            { value: "Dry fruits", text: t("Q14.options.Q14C6"), id: "Q14C6" },
            { value: "Sweets", text: t("Q14.options.Q14C7"), id: "Q14C7" },
            { value: "Fruits", text: t("Q14.options.Q14C8"), id: "Q14C8" },
            {
              value: "Bhakri / Chapati / Oats / Cornflakes",
              text: t("Q14.options.Q14C9"),
              id: "Q14C9",
            },
            {
              value: "Vegetables",
              text: t("Q14.options.Q14C10"),
              id: "Q14C10",
            },
            {
              value: "Dal / Pulses",
              text: t("Q14.options.Q14C11"),
              id: "Q14C11",
            },
            { value: "Non -Veg", text: t("Q14.options.Q14C12"), id: "Q14C12" },
            {
              value: "Oily / Fried",
              text: t("Q14.options.Q14C13"),
              id: "Q14C13",
            },
            {
              value: "I don't eat breakfast",
              text: t("Q14.options.Q14C14"),
              id: "Q14C14",
              exclusive: true,
            },
          ]}
          nextConfig={{ optionCode: "Q14C14", nextStep: 16 }}
          isPillView={true}
          initState={getSubState("BreakfastPref")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q15.question")}
          questionCode={"Q15"}
          choices={[
            { value: "Before 7am", text: t("Q15.options.Q15C1"), id: "Q15C1" },
            { value: "7am - 10am", text: t("Q15.options.Q15C2"), id: "Q15C2" },
            { value: "After 10am", text: t("Q15.options.Q15C3"), id: "Q15C3" },
          ]}
          initState={getSubState("BreakfastTime")}
          qKey={"BreakfastTime"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          pageTitle={t("hi.title")}
          qKey={"LunchPref"}
          question={t("Q16.question")}
          questionCode={"Q16"}
          choices={[
            {
              value: "Bhakri / Chapati / Oats / Cornflakes",
              text: t("Q16.options.Q16C1"),
              id: "Q16C1",
            },
            { value: "Vegetables", text: t("Q16.options.Q16C2"), id: "Q16C2" },
            {
              value: "Dal / Pulses",
              text: t("Q16.options.Q16C3"),
              id: "Q16C3",
            },
            { value: "Non -Veg", text: t("Q16.options.Q16C4"), id: "Q16C4" },
            {
              value: "Rice / Idli / Dosa",
              text: t("Q16.options.Q16C5"),
              id: "Q16C5",
            },
            {
              value: "Oily / Fried",
              text: t("Q16.options.Q16C6"),
              id: "Q16C6",
            },
            { value: "Dry fruits", text: t("Q16.options.Q16C7"), id: "Q16C7" },
            {
              value: "Bread / Biscuits",
              text: t("Q16.options.Q16C8"),
              id: "Q16C8",
            },
            {
              value: "Milk / Yogurt / Paneer / Cheese",
              text: t("Q16.options.Q16C9"),
              id: "Q16C9",
            },
            { value: "Fruits", text: t("Q16.options.Q16C10"), id: "Q16C10" },
            {
              value: "Poha / Upma",
              text: t("Q16.options.Q16C11"),
              id: "Q16C11",
            },
            {
              value: "Tea / Coffee",
              text: t("Q16.options.Q16C12"),
              id: "Q16C12",
            },
            {
              value: "I don't eat lunch",
              text: t("Q16.options.Q16C13"),
              id: "Q16C13",
              exclusive: true,
            },
          ]}
          nextConfig={{ optionCode: "Q16C13", nextStep: 18 }}
          isPillView={true}
          initState={getSubState("LunchPref")}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q17.question")}
          questionCode={"Q17"}
          choices={[
            { value: "Before 12pm", text: t("Q17.options.Q17C1"), id: "Q17C1" },
            { value: "12pm - 2pm", text: t("Q17.options.Q17C2"), id: "Q17C2" },
            { value: "After 2pm", text: t("Q17.options.Q17C3"), id: "Q17C3" },
          ]}
          initState={getSubState("LunchTime")}
          qKey={"LunchTime"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          pageTitle={t("hi.title")}
          qKey={"DinnerPref"}
          question={t("Q18.question")}
          questionCode={"Q18"}
          choices={[
            {
              value: "Bhakri / Chapati / Oats / Cornflakes",
              text: t("Q18.options.Q18C1"),
              id: "Q18C1",
            },
            { value: "Vegetables", text: t("Q18.options.Q18C2"), id: "Q18C2" },
            {
              value: "Dal / Pulses",
              text: t("Q18.options.Q18C3"),
              id: "Q18C3",
            },
            { value: "Non -Veg", text: t("Q18.options.Q18C4"), id: "Q18C4" },
            {
              value: "Rice / Idli / Dosa",
              text: t("Q18.options.Q18C5"),
              id: "Q18C5",
            },
            {
              value: "Oily / Fried",
              text: t("Q18.options.Q18C6"),
              id: "Q18C6",
            },
            { value: "Dry fruits", text: t("Q18.options.Q18C7"), id: "Q18C7" },
            {
              value: "Bread / Biscuits",
              text: t("Q18.options.Q18C8"),
              id: "Q18C8",
            },
            {
              value: "Milk / Yogurt / Paneer / Cheese",
              text: t("Q18.options.Q18C9"),
              id: "Q18C9",
            },
            { value: "Fruits", text: t("Q18.options.Q18C10"), id: "Q18C10" },
            {
              value: "Poha / Upma",
              text: t("Q18.options.Q18C11"),
              id: "Q18C11",
            },
            {
              value: "Tea / Coffee",
              text: t("Q18.options.Q18C12"),
              id: "Q18C12",
            },
            {
              value: "I don't eat dinner",
              text: t("Q18.options.Q18C13"),
              id: "Q18C13",
              exclusive: true,
            },
          ]}
          nextConfig={{ optionCode: "Q18C13", nextStep: 20 }}
          isPillView={true}
          hideLibrary={true}
          initState={getSubState("DinnerPref")}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q19.question")}
          questionCode={"Q19"}
          choices={[
            { value: "Before 7pm", text: t("Q19.options.Q19C1"), id: "Q19C1" },
            { value: "7pm - 11pm", text: t("Q19.options.Q19C2"), id: "Q19C2" },
            { value: "After 11pm", text: t("Q19.options.Q19C3"), id: "Q19C3" },
          ]}
          initState={getSubState("DinnerTime")}
          qKey={"DinnerTime"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <SingleChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q20.question")}
          questionCode={"Q20"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q20C1" },
            { value: "No", text: t("hi.no"), id: "Q20C2" },
          ]}
          nextConfig={{ optionCode: "Q20C2", nextStep: 22 }}
          initState={getSubState("IsExercise")}
          qKey={"IsExercise"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MultiChoiceStep
          pageTitle={t("hi.title")}
          question={t("Q21.question")}
          questionCode={"Q21"}
          choices={[
            {
              value: "Joint exercise",
              text: t("Q21.options.Q21C1"),
              id: "Q21C1",
            },
            {
              value: "Back exercise",
              text: t("Q21.options.Q21C2"),
              id: "Q21C2",
            },
            {
              value: "Physiotherapy exercise",
              text: t("Q21.options.Q21C3"),
              id: "Q21C3",
            },
            { value: "Walking", text: t("Q21.options.Q21C4"), id: "Q21C4" },
            { value: "Yoga", text: t("Q21.options.Q21C5"), id: "Q21C5" },
          ]}
          nextConfig={{ optionCode: "Q21C2", nextStep: 22 }}
          initState={getSubState("ExerciseType")}
          qKey={"ExerciseType"}
          hideLibrary={true}
          onSubmitHandler={updateStatus}
        />
        <MedicalHistoryStep
          pageTitle={t("hi.title")}
          question={t("Q22.question")}
          questionCode={"Q22"}
          choices={[
            { value: "Yes", text: t("hi.yes"), id: "Q22C1" },
            { value: "No", text: t("hi.no"), id: "Q22C2" },
          ]}
          yesChoiceCode={"Q22C1"}
          yesDescription={t("Q22.yesText")}
          qKey={"IsPhysioConsulted"}
          initState={getSubState("IsPhysioConsulted")}
          hideLibrary={true}
          onSubmitText={t("hi.submit")}
          onSubmitHandler={updateStatus}
        />
        <SubmitStep data={state} fromRoute={fromRoute} rawFrom={rawFrom} />
      </Wizard>
    </>
  );
}

export default HealthInfoWizard;
